import React from "react";
import Layout from "../Layout";
import "./styles.css";
const MsbtePageSection = () => {
    return (
        <Layout>
            <div className="nfssc-container">
                <div className="container py-3">
                    <div className="row">
                        <div className="col-12">
                            {" "}
                            <h1 className="nfssc-title">MSBTE Program</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="details-box">
                                <p>
                                     The MSBTE Program is gaining popularity among students in India as a strong foundation for technical and diploma-based careers. It plays a vital role in developing industry-ready skills and reflects the growing demand for technical education and industrial growth.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="row my-2">
                                <div className="col-md-6 col-12 my-3">
                                    <div className="card maincus-card">
                                        <div className="card-body cus-program-card">
                                            <div className="cus-sepret">
                                                <div>
                                                    <h3>Sr.No</h3>
                                                </div>
                                                <div>
                                                    <h4>1</h4>
                                                </div>
                                            </div>
                                            <div className="cus-sepret">
                                                <div>
                                                    <h3>Course Name</h3>
                                                </div>
                                                <div>
                                                    <h4>ADIS - Advance Diploma In Industrial Safety</h4>
                                                </div>
                                            </div>

                                            <div className="cus-sepret">
                                                <div>
                                                    <h3>Duration Medium</h3>
                                                </div>
                                                <div>
                                                    <h4>1 Year</h4>
                                                </div>
                                            </div>
                                            <div className="cus-sepret">
                                                <div>
                                                    <h3>Eligibility</h3>
                                                </div>
                                                <div>
                                                    <h4>Any Science Graduate/ B.Tech / Diploma in Engineering</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-12 my-3">
                                    <div className="card maincus-card">
                                        <div className="card-body cus-program-card">
                                            <div className="cus-sepret">
                                                <div>
                                                    <h3>Sr.No</h3>
                                                </div>
                                                <div>
                                                    <h4>2</h4>
                                                </div>
                                            </div>
                                            <div className="cus-sepret">
                                                <div>
                                                    <h3>Course Name</h3>
                                                </div>
                                                <div>
                                                    <h4>FR- Diploma In Fire Service Engineering </h4>
                                                </div>
                                            </div>

                                            <div className="cus-sepret">
                                                <div>
                                                    <h3>Duration Medium</h3>
                                                </div>
                                                <div>
                                                    <h4>2 Year</h4>
                                                </div>
                                            </div>
                                            <div className="cus-sepret">
                                                <div>
                                                    <h3>Eligibility</h3>
                                                </div>
                                                <div>
                                                    <h4>10th (SSC) / 2-year ITI / Diploma in Engineering</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};
export default MsbtePageSection;
